{
  "set": "Little Bankers UI icons",
  "sprite": "little-bankers-icons.svg",
  "viewBox": "0 0 24 24",
  "strokeWidth": 1.8,
  "ink": "#1b2a4a",
  "reuseExisting": [
    "CoinIcon",
    "VaultIcon",
    "OinkIcon",
    "piggington-sprite.svg"
  ],
  "pending": [
    {
      "id": "ic-wish",
      "note": "wish-goal / ask-link placement awaiting sign-off — drawn, hold before shipping"
    }
  ],
  "icons": [
    {
      "id": "ic-home",
      "label": "Home tab",
      "group": "Parent — navigation & shell",
      "category": "slate"
    },
    {
      "id": "ic-kids",
      "label": "Kids tab (ungendered)",
      "group": "Parent — navigation & shell",
      "category": "slate"
    },
    {
      "id": "ic-requests",
      "label": "Requests / approve",
      "group": "Parent — navigation & shell",
      "category": "slate"
    },
    {
      "id": "ic-gear",
      "label": "Settings",
      "group": "Parent — navigation & shell",
      "category": "slate"
    },
    {
      "id": "ic-lock",
      "label": "Mode locked",
      "group": "Parent — navigation & shell",
      "category": "slate"
    },
    {
      "id": "ic-unlock",
      "label": "Unlock to Kid Mode",
      "group": "Parent — navigation & shell",
      "category": "slate"
    },
    {
      "id": "ic-wand",
      "label": "Setup wizard",
      "group": "Parent — navigation & shell",
      "category": "slate"
    },
    {
      "id": "ic-till",
      "label": "Spend (Till)",
      "group": "Parent — quick actions & Do now",
      "category": "slate"
    },
    {
      "id": "ic-medal",
      "label": "Award / earning activities",
      "group": "Parent — quick actions & Do now",
      "category": "gold"
    },
    {
      "id": "ic-plus",
      "label": "Add",
      "group": "Parent — quick actions & Do now",
      "category": "gold"
    },
    {
      "id": "ic-banknote",
      "label": "Household money",
      "group": "Parent — quick actions & Do now",
      "category": "gold"
    },
    {
      "id": "ic-flame",
      "label": "Habits & streaks",
      "group": "Parent — kid-page sections",
      "category": "slate"
    },
    {
      "id": "ic-brain",
      "label": "Learn & Earn",
      "group": "Parent — kid-page sections",
      "category": "slate"
    },
    {
      "id": "ic-cap",
      "label": "Spending cap",
      "group": "Parent — kid-page sections",
      "category": "slate"
    },
    {
      "id": "ic-goals",
      "label": "Goals",
      "group": "Parent — kid-page sections",
      "category": "teal"
    },
    {
      "id": "ic-gift",
      "label": "Experience rewards",
      "group": "Parent — kid-page sections",
      "category": "slate"
    },
    {
      "id": "ic-fix",
      "label": "Fix a balance",
      "group": "Parent — kid-page sections",
      "category": "rose"
    },
    {
      "id": "ic-recent",
      "label": "Recent activity",
      "group": "Parent — kid-page sections",
      "category": "slate"
    },
    {
      "id": "ic-everyone",
      "label": "\"For everyone\" badge",
      "group": "Parent — kid-page sections",
      "category": "slate"
    },
    {
      "id": "ic-edit",
      "label": "Edit profile",
      "group": "Parent — kid-page sections",
      "category": "slate"
    },
    {
      "id": "ic-choice",
      "label": "The choice moment",
      "group": "Till & choice screen",
      "category": "slate"
    },
    {
      "id": "ic-buy",
      "label": "Buy it now",
      "group": "Till & choice screen",
      "category": "slate"
    },
    {
      "id": "ic-supersaver",
      "label": "Super saver",
      "group": "Till & choice screen",
      "category": "teal"
    },
    {
      "id": "ic-sent",
      "label": "Request sent",
      "group": "Till & choice screen",
      "category": "slate"
    },
    {
      "id": "ic-photo",
      "label": "Photo / proof",
      "group": "Till & choice screen",
      "category": "slate"
    },
    {
      "id": "ic-pending",
      "label": "Pending",
      "group": "Till & choice screen",
      "category": "slate"
    },
    {
      "id": "ic-reassure",
      "label": "Reassurance",
      "group": "Till & choice screen",
      "category": "pink"
    },
    {
      "id": "ic-celebrate",
      "label": "Celebration",
      "group": "Till & choice screen",
      "category": "gold"
    },
    {
      "id": "ic-arcade",
      "label": "Arcade",
      "group": "Kid mode",
      "category": "indigo"
    },
    {
      "id": "ic-trophy",
      "label": "Trophy Cabinet",
      "group": "Kid mode",
      "category": "gold"
    },
    {
      "id": "ic-star",
      "label": "Top goal star",
      "group": "Kid mode",
      "category": "gold"
    },
    {
      "id": "ic-wish",
      "label": "Wish goal (pending sign-off)",
      "group": "Kid mode",
      "category": "gold"
    },
    {
      "id": "ic-spelling",
      "label": "Spelling",
      "group": "Kid mode",
      "category": "slate"
    },
    {
      "id": "ic-vocab",
      "label": "Vocabulary",
      "group": "Kid mode",
      "category": "slate"
    },
    {
      "id": "ic-attention",
      "label": "Attention strip",
      "group": "System & misc",
      "category": "amber"
    },
    {
      "id": "ic-bell",
      "label": "Notifications",
      "group": "System & misc",
      "category": "slate"
    },
    {
      "id": "ic-pin",
      "label": "Parent PIN",
      "group": "System & misc",
      "category": "slate"
    },
    {
      "id": "ic-devices",
      "label": "Devices",
      "group": "System & misc",
      "category": "slate"
    },
    {
      "id": "ic-children",
      "label": "Wizard: children",
      "group": "System & misc",
      "category": "slate"
    },
    {
      "id": "ic-install",
      "label": "Install app",
      "group": "System & misc",
      "category": "slate"
    },
    {
      "id": "ic-help",
      "label": "Help & FAQ",
      "group": "System & misc",
      "category": "slate"
    },
    {
      "id": "ic-exchange",
      "label": "Token exchange",
      "group": "System & misc",
      "category": "gold"
    },
    {
      "id": "ic-close",
      "label": "Close",
      "group": "System & misc",
      "category": "slate"
    },
    {
      "id": "ic-back",
      "label": "Back",
      "group": "System & misc",
      "category": "slate"
    },
    {
      "id": "ic-forward",
      "label": "Forward",
      "group": "System & misc",
      "category": "slate"
    },
    {
      "id": "ic-times-tables",
      "label": "Times tables",
      "group": "Kid mode",
      "category": "slate"
    },
    {
      "id": "ic-maths",
      "label": "Maths workout",
      "group": "Kid mode",
      "category": "slate"
    },
    {
      "id": "ic-chevron-down",
      "label": "Expand (collapsible rows)",
      "group": "System & misc",
      "category": "slate"
    },
    {
      "id": "ic-chevron-up",
      "label": "Collapse (collapsible rows)",
      "group": "System & misc",
      "category": "slate"
    },
    {
      "id": "ic-check",
      "label": "Done tick (task rows, verified states)",
      "group": "System & misc",
      "category": "slate"
    }
  ],
  "tintable": {
    "note": "Every stroke and fill is currentColor. One asset per icon serves every register — set `color`.",
    "fillOpacityVar": "--ic-fill",
    "fillOpacityDefault": 0.14
  },
  "palette": {
    "slate": {
      "hex": "#5A6478",
      "use": "parent navigation & sections — state colour does the talking"
    },
    "gold": {
      "hex": "#E0A81C",
      "use": "tokens: earn, award, exchange — anchors to CoinIcon"
    },
    "teal": {
      "hex": "#0F9B8E",
      "use": "vault & saving — anchors to VaultIcon and the progress bars"
    },
    "pink": {
      "hex": "#E86A92",
      "use": "the Piggington family: pig, Oinks, shop"
    },
    "indigo": {
      "hex": "#5B5BD6",
      "use": "play: arcade"
    },
    "amber": {
      "hex": "#D97706",
      "use": "attention only — never decorative"
    },
    "rose": {
      "hex": "#E11D48",
      "use": "warnings & deductions only — never decorative"
    }
  },
  "reserved": [
    "amber",
    "rose"
  ],
  "neutralityRule": "ic-buy and ic-goals sit on the choice screen and must never be given hues of different warmth or salience — either both slate, or both the same category treatment. A hue that makes one option \"the good one\" breaks that screen.",
  "notes": " ic-supersaver is a rosette, not a flexed arm: a bicep needs skin tone, finger divisions and a coloured sleeve to read, none of which survive single-tone line art at 24px.",
  "brainIcon": {
    "source": "uploads/brain-icon.svg + brain-icon-spec.md",
    "note": "Two abutting hemispheres sharing the x=50 midline (not one shape with a line drawn on it), heart cleft top and bottom, hook-shaped folds, no stem or cerebellum. Ported onto the 24 grid via a group transform, with stroke widths pre-divided by the scale so painted weight is 1.8 outline / 1.44 folds — the spec's 0.8 ratio. Rendered in the set's tintable single tone (the spec's slate-family alternate) rather than fixed pink, so it stays consistent with the other 46 and recolours by CSS. If the pink is wanted, override color and --ic-fill on this one icon.",
    "doNot": "Do not re-scale with a non-uniform transform, add a brainstem, or draw the midline as a separate line."
  }
}
